import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';

export function QualifyingCriteria() {
  return (
    <section className="bg-background pb-16 pt-10 md:pb-24 md:pt-14">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 md:max-w-5xl lg:px-8">
        <RichTextContent
          path="qualifyingcriteria.blurb"
          label="Page Blurb"
          defaultValue="<p>Qualifying Rental Criteria</p><p>Touring: Government issued I.D is required to tour.</p><p>Income: Income verification is required during the application process.</p><p>Credit/Criminal: Unsatisfactory credit may require additional deposit &amp; criminal background checks are required.</p>"
          as="div"
          className="font-body text-sm leading-relaxed text-muted-foreground sm:text-base [&_p]:mb-4 [&_p:last-child]:mb-0"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'QualifyingCriteria',
  displayName: 'Qualifying Criteria',
  tokens: {
    'qualifyingcriteria.blurb': {
      label: 'Page Blurb',
      type: 'richtext',
      defaultValue:
        '<p>Qualifying Rental Criteria</p><p>Touring: Government issued I.D is required to tour.</p><p>Income: Income verification is required during the application process.</p><p>Credit/Criminal: Unsatisfactory credit may require additional deposit &amp; criminal background checks are required.</p>',
    },
  },
};

(QualifyingCriteria as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default QualifyingCriteria;
